<template>
  <div id="lom-award-preview" class="professional-preview-dialog">
    <v-card class="main-preview-container" elevation="8">
      <!-- Professional App Bar -->
      <div class="professional-app-bar">
        <div class="app-bar-background">
          <div class="background-pattern"></div>
          <div class="background-overlay"></div>
        </div>

        <div class="app-bar-content">
          <div class="left-section">
            <div class="app-bar-icon-wrapper">
              <v-icon size="32" color="white" class="app-bar-icon"
                >mdi-trophy-award</v-icon
              >
            </div>
            <div class="title-content">
              <h1 class="app-bar-title">{{ PageTitle }}</h1>
              <div v-if="PageDescription" class="app-bar-subtitle">
                {{ PageDescription }}
              </div>
            </div>
          </div>

          <div class="right-section">
            <div class="action-buttons-wrapper">
              <v-btn @click="closePrompt" class="close-button" outlined>
                <v-icon left size="18">mdi-close</v-icon>
                Close
              </v-btn>
            </div>
          </div>
        </div>
      </div>

      <!-- Loading -->
      <div class="professional-loading-section" v-if="LoadingFlag">
        <div class="loading-container">
          <v-progress-circular
            indeterminate
            size="64"
            width="4"
            color="#1976d2"
          ></v-progress-circular>
          <p class="loading-text mt-4">Loading award details...</p>
        </div>
      </div>

      <!-- Main content -->
      <v-card-text
        class="main-content-wrapper"
        v-if="row != '' && !LoadingFlag"
      >
        <v-container class="py-0">
          <!-- Award Details -->
          <div class="award-section-card mb-4">
            <div class="section-header">
              <div class="section-title-wrapper">
                <v-icon size="24" color="#1976d2" class="mr-2"
                  >mdi-certificate</v-icon
                >
                <h3 class="section-title">Award Details</h3>
              </div>
            </div>

            <div class="section-content">
              <v-row>
                <v-col cols="12" sm="6" lg="3">
                  <div class="detail-item">
                    <h6 class="detail-label">Award Status</h6>
                    <div class="status-chip-wrapper">
                      <v-chip
                        :color="row.AwardStatusColor"
                        class="status-chip elevation-2"
                        label
                      >
                        <v-icon left size="16">mdi-flag</v-icon>
                        {{ row.AwardStatusTxt }}
                      </v-chip>
                    </div>
                  </div>
                </v-col>

                <v-col cols="12" sm="6" lg="3">
                  <div class="detail-item">
                    <h6 class="detail-label">Register Number</h6>
                    <p class="detail-value">{{ row.AwardRegisterNumber }}</p>
                  </div>
                </v-col>

                <v-col cols="12" sm="6" lg="3">
                  <div class="detail-item">
                    <h6 class="detail-label">Award Type</h6>
                    <p class="detail-value">{{ row.AwardTypeTitleTxt }}</p>
                  </div>
                </v-col>

                <v-col cols="12" sm="6" lg="3">
                  <div class="detail-item">
                    <h6 class="detail-label">Award Category</h6>
                    <p class="detail-value">{{ row.AwardCategoryName }}</p>
                  </div>
                </v-col>
              </v-row>
            </div>
          </div>

          <!-- Nominee Details -->
          <div class="award-section-card mb-4">
            <div class="section-header">
              <div class="section-title-wrapper">
                <v-icon size="24" color="#1976d2" class="mr-2"
                  >mdi-account-circle</v-icon
                >
                <h3 class="section-title">Nominee Details</h3>
              </div>
            </div>

            <div class="section-content">
              <div class="member-photo-section" v-if="row.MemberImage != ''">
                <div class="photo-container">
                  <v-avatar size="120" class="member-avatar elevation-4">
                    <v-img
                      :src="row.MemberImage"
                      :alt="row.MemberFullName"
                      cover
                    ></v-img>
                  </v-avatar>
                  <div class="photo-overlay">
                    <v-icon color="white" size="20">mdi-camera</v-icon>
                  </div>
                </div>
              </div>

              <v-row class="mt-4">
                <v-col cols="12" sm="6" lg="3">
                  <div class="detail-item">
                    <h6 class="detail-label">
                      <v-icon size="16" class="mr-1">mdi-account</v-icon> Full
                      Name
                    </h6>
                    <p class="detail-value">{{ row.MemberFullName }}</p>
                  </div>
                </v-col>

                <v-col cols="12" sm="6" lg="3">
                  <div class="detail-item">
                    <h6 class="detail-label">
                      <v-icon size="16" class="mr-1">mdi-account-box</v-icon>
                      Membership ID
                    </h6>
                    <p class="detail-value">{{ row.MembershipId }}</p>
                  </div>
                </v-col>

                <v-col cols="12" sm="6" lg="3">
                  <div class="detail-item">
                    <h6 class="detail-label">
                      <v-icon size="16" class="mr-1">mdi-email</v-icon> Email
                      Address
                    </h6>
                    <p class="detail-value">{{ row.EmailId }}</p>
                  </div>
                </v-col>

                <v-col cols="12" sm="6" lg="3">
                  <div class="detail-item">
                    <h6 class="detail-label">
                      <v-icon size="16" class="mr-1">mdi-phone</v-icon> Mobile
                      Number
                    </h6>
                    <p class="detail-value">{{ row.MobileNo }}</p>
                  </div>
                </v-col>
              </v-row>
            </div>
          </div>

          <!-- Score Details -->
          <div class="award-section-card mb-4 score-details-section">
            <div class="section-header">
              <div class="section-title-wrapper">
                <v-icon size="24" color="#7c4dff" class="mr-2"
                  >mdi-chart-bar</v-icon
                >
                <h3 class="section-title">Score Details</h3>
              </div>
            </div>

            <div class="section-content">
              <v-row wrap class="justify-center">
                <v-col cols="12">
                  <v-card
                    v-if="
                      row.AwardJciPointsData &&
                      Array.isArray(row.AwardJciPointsData) &&
                      row.AwardJciPointsData.length
                    "
                    class="pa-4 elevation-3 rounded-xl score-card full-width-card"
                  >
                    <h5
                      class="text-center mb-4 font-weight-bold deep-purple--text score-title"
                    >
                      JCI Points Summary
                    </h5>

                    <v-simple-table class="award-jci-table responsive-table">
                      <thead>
                        <tr>
                          <th class="text-center">Criteria</th>
                          <th class="text-center">Max Points</th>
                          <th class="text-center">Received Points</th>
                        </tr>
                      </thead>
                      <tbody>
                        <template
                          v-for="(item, index) in row.AwardJciPointsData"
                        >
                          <tr :key="'row-' + index" class="score-row">
                            <td
                              class="font-weight-medium criteria-cell"
                              style="height: 73px"
                            >
                              <v-icon size="18" color="#7c4dff" class="mr-1"
                                >mdi-check-circle</v-icon
                              >
                              <span class="criteria-text">{{
                                item.Criteria
                              }}</span>
                            </td>
                            <td class="max-points-cell">
                              {{ item.MaxPoints }}
                            </td>
                            <td>
                              <v-chip
                                class="font-weight-bold score-chip"
                                :style="{
                                  backgroundColor: item.PointsColor
                                    ? item.PointsColor
                                    : '#ede7f6',
                                  color: '#222',
                                  fontSize: '16px',
                                  minWidth: '48px',
                                  justifyContent: 'center',
                                  boxShadow: '0 2px 8px rgba(124,77,255,0.10)',
                                }"
                                large
                              >
                                {{ item.ReceivedPoints }}
                              </v-chip>
                            </td>
                          </tr>
                        </template>

                        <tr class="score-total-row">
                          <td class="font-weight-bold text-left" colspan="2">
                            <v-icon size="18" color="#1976d2" class="mr-1"
                              >mdi-sigma</v-icon
                            >
                            Total
                          </td>
                          <td class="font-weight-bold">
                            {{
                              row.AwardJciPointsData.reduce(
                                (sum, item) =>
                                  sum + Number(item.ReceivedPoints || 0),
                                0
                              )
                            }}
                          </td>
                        </tr>
                      </tbody>
                    </v-simple-table>
                  </v-card>

                  <v-card v-else class="award-section-card">
                    <div class="no-score-data text-center py-6">
                      <v-icon color="#bdbdbd" size="64" class="mb-3"
                        >mdi-alert-circle-outline</v-icon
                      >
                      <h4
                        class="grey--text text--darken-1 font-weight-bold mb-2"
                      >
                        No JCI Points Found
                      </h4>
                      <p class="grey--text mb-0">
                        JCI Points Summary will be displayed here once
                        evaluation data becomes available.
                      </p>
                    </div>
                  </v-card>
                </v-col>
              </v-row>
            </div>
          </div>

          <hr />

          <!-- Judging Criteria Details -->
          <div class="award-section-card">
            <div class="section-header">
              <div class="section-title-wrapper">
                <v-icon size="24" color="#1976d2" class="mr-2"
                  >mdi-clipboard-list</v-icon
                >
                <h3 class="section-title">Judging Criteria Details</h3>
              </div>
            </div>

            <div class="section-content">
              <div
                v-for="(item, index) in row.AwardAnswersArray"
                :key="index"
                class="criteria-item-wrapper"
              >
                <div
                  class="criteria-title-section"
                  v-if="item.CriteriaTitleFlag"
                >
                  <div class="criteria-title-card">
                    <div class="criteria-title-content">
                      <h4 class="criteria-main-title">
                        <v-icon size="20" color="#4caf50" class="mr-2"
                          >mdi-bookmark</v-icon
                        >
                        {{ item.CriteriaTitle }}
                      </h4>
                      <div class="criteria-score-badge">
                        <v-chip
                          color="#4caf50"
                          text-color="white"
                          small
                          class="score-chip"
                        >
                          <v-icon left size="14">mdi-star</v-icon>
                          Score: {{ item.CriteriaScore }}
                        </v-chip>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="question-answer-section">
                  <div class="question-card">
                    <div class="question-header">
                      <v-icon size="18" color="#ff9800" class="mr-2"
                        >mdi-help-circle</v-icon
                      >
                      <h6 class="question-label">Question</h6>
                    </div>
                    <p class="question-text">{{ item.QuestionsText }}</p>
                  </div>

                  <div class="answer-card mt-3">
                    <div class="answer-header">
                      <v-icon size="18" color="#2196f3" class="mr-2"
                        >mdi-message-reply</v-icon
                      >
                      <h6 class="answer-label">Answer</h6>
                    </div>
                    <div class="answer-content">
                      <p class="answer-text" v-html="item.AnswerText"></p>
                    </div>
                  </div>
                </div>

                <div
                  class="attachments-section"
                  v-if="item.EventDetails.length > 0"
                >
                  <div class="attachments-header">
                    <div class="attachments-title-wrapper">
                      <v-icon size="20" color="#9c27b0" class="mr-2"
                        >mdi-attachment</v-icon
                      >
                      <h6 class="attachments-title">
                        Award Attachments
                        <span class="attachment-count"
                          >(Max: {{ item.QuestionsAttachmentMax }})</span
                        >
                      </h6>
                    </div>
                  </div>

                  <div class="attachments-grid">
                    <v-row>
                      <v-col
                        cols="12"
                        sm="6"
                        md="4"
                        lg="3"
                        v-for="(data, k) in item.EventDetails"
                        :key="k"
                      >
                        <v-card class="attachment-card elevation-3">
                          <div class="attachment-card-header">
                            <v-icon color="white" size="20"
                              >mdi-calendar-check</v-icon
                            >
                            <span class="attachment-card-title"
                              >Event {{ k + 1 }}</span
                            >
                          </div>

                          <v-card-text class="attachment-content">
                            <div
                              v-if="
                                data.EventImagesArray &&
                                data.EventImagesArray.length > 0
                              "
                              class="event-images-section"
                            >
                              <viewer rebuild :images="data.EventImagesArray">
                                <div class="images-gallery">
                                  <div
                                    class="image-thumbnail"
                                    v-for="(
                                      src, imgIndex
                                    ) in data.EventImagesArray"
                                    :key="imgIndex"
                                  >
                                    <img
                                      :src="src"
                                      :alt="`Event image ${imgIndex + 1}`"
                                      class="thumbnail-image"
                                    />
                                    <div class="image-overlay">
                                      <v-icon color="white" size="16"
                                        >mdi-magnify-plus</v-icon
                                      >
                                    </div>
                                  </div>
                                </div>
                              </viewer>
                            </div>

                            <div class="event-details-section">
                              <div class="event-detail-item">
                                <div class="detail-icon-wrapper">
                                  <v-icon size="16" color="#1976d2"
                                    >mdi-calendar</v-icon
                                  >
                                </div>
                                <div class="detail-content">
                                  <span class="detail-label-small">Date</span>
                                  <span class="detail-value-small">{{
                                    data.EventDate
                                  }}</span>
                                </div>
                              </div>

                              <div class="event-detail-item mt-2">
                                <div class="detail-icon-wrapper">
                                  <v-icon size="16" color="#1976d2"
                                    >mdi-calendar-star</v-icon
                                  >
                                </div>
                                <div class="detail-content">
                                  <span class="detail-label-small">Event</span>
                                  <span class="detail-value-small">{{
                                    data.EventName
                                  }}</span>
                                </div>
                              </div>
                            </div>
                          </v-card-text>
                        </v-card>
                      </v-col>
                    </v-row>
                  </div>
                </div>

                <v-divider
                  class="criteria-divider"
                  v-if="index < row.AwardAnswersArray.length - 1"
                ></v-divider>
              </div>
            </div>
            <br />
            <!-- Attachments - Modernized -->
            <template
              v-if="
                row.AnswerAttachmentOfficers &&
                row.AnswerAttachmentOfficers.length > 0
              "
            >
              <div class="award-section-card mb-4">
                <div class="section-header">
                  <div class="section-title-wrapper">
                    <v-icon size="24" color="#9c27b0" class="mr-2"
                      >mdi-image-multiple</v-icon
                    >
                    <h3 class="section-title">Other Attachments</h3>
                  </div>
                </div>

                <div class="section-content">
                  <v-row wrap class="mt-2">
                    <v-col
                      cols="12"
                      sm="6"
                      md="4"
                      lg="3"
                      v-for="(data, k) in row.AnswerAttachmentOfficers"
                      :key="k"
                    >
                      <v-card class="attachment-preview-card" elevation="3">
                        <div class="attachment-preview-header">
                          <v-icon color="white" size="18">mdi-image</v-icon>
                          <span class="attachment-preview-title"
                            >Image {{ k + 1 }}</span
                          >
                        </div>

                        <v-card-text class="attachment-preview-content">
                          <div
                            v-if="
                              data.EventImagesArray &&
                              data.EventImagesArray.length > 0
                            "
                            class="attachment-images"
                          >
                            <viewer rebuild :images="data.EventImagesArray">
                              <div class="images-grid">
                                <div
                                  v-for="(src, idx) in data.EventImagesArray"
                                  :key="idx"
                                  class="image-preview-item"
                                >
                                  <img
                                    :src="src"
                                    :alt="`Attachment image ${idx + 1}`"
                                    class="preview-img"
                                  />
                                  <div class="image-overlay-preview">
                                    <v-icon color="white" size="16"
                                      >mdi-magnify-plus</v-icon
                                    >
                                  </div>
                                </div>
                              </div>
                            </viewer>
                          </div>

                          <div class="attachment-details-info">
                            <div class="detail-row-preview">
                              <v-icon size="16" color="#9c27b0" class="mr-2"
                                >mdi-calendar</v-icon
                              >
                              <span class="detail-label-preview">Date:</span>
                              <span class="detail-value-preview">{{
                                data.EventDate
                              }}</span>
                            </div>
                            <div class="detail-row-preview mt-2">
                              <v-icon size="16" color="#9c27b0" class="mr-2"
                                >mdi-tag</v-icon
                              >
                              <span class="detail-label-preview">Name:</span>
                              <span class="detail-value-preview">{{
                                data.EventName
                              }}</span>
                            </div>
                          </div>
                        </v-card-text>
                      </v-card>
                    </v-col>
                  </v-row>
                </div>
              </div>
            </template>

            <!-- Video - Modernized -->
            <div v-if="row.AwardVideoPath != null" class="award-section-card">
              <div class="section-header">
                <div class="section-title-wrapper">
                  <v-icon size="24" color="blue" class="mr-2"
                    >mdi-video</v-icon
                  >
                  <h3 class="section-title-blue">Video Submission</h3>
                </div>
              </div>
              <div class="section-content">
                <div class="video-submission-wrapper">
                  <div class="video-info-alert">
                    <v-icon color="#d32f2f" class="mr-2"
                      >mdi-information-outline</v-icon
                    >
                    <div>
                      <strong class="video-alert-title">Video Format:</strong>
                      <p class="video-alert-text">
                        MP4, AVI, or MOV format • Maximum 25MB
                      </p>
                    </div>
                  </div>

                  <div class="video-player-container">
                    <video
                      :src="row.AwardVideoPath"
                      width="100%"
                      controls
                      class="video-player"
                    ></video>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </v-container>
      </v-card-text>

      <v-card-actions class="professional-footer-actions">
        <div class="footer-content-centered">
          <v-btn
            @click="closePrompt"
            class="professional-close-btn"
            large
            elevation="3"
            color="#1976d2"
          >
            <v-icon left size="20">mdi-close-circle</v-icon>
            Close Preview
          </v-btn>
        </div>
      </v-card-actions>
    </v-card>
  </div>
</template>
<script>
import common from "@/view/Common.vue";
import companyConfig from "@/company_config.json";
import Swal from "sweetalert2";

export default {
  mixins: [common],
  components: {},
  props: {
    previewRecordPrompt: {
      required: true,
      Type: Boolean,
    },
    recordData: {
      required: true,
    },
  },
  data() {
    return {
      valid1: true,
      search: "",
      StartupLoadingFlag: false,
      LoadingFlag: false,
      SubmitFlag: false,

      ProgessStart: 0,
      uploadPercentage: 0,

      tab: "",

      row: [],

      addRecordPrompt: false,
      editRecordPrompt: false,

      ActiveStatus: "",

      valid: true,

      RoleId: "",
      PageInfo: {},
      PageTitle: "",
      PageDescription: "",
      CurrentYearId: 0,
      YearName: "",
      NextYearCode: "",
      NextYearName: "",
    };
  },
  computed: {},
  watch: {
    PageInfo: function () {
      console.log("watch PageInfo");
      this.LoadingFlag = false;
      var tr = this.PageInfo;
      console.log({ tr });
      var n1 = Object.keys(tr).length;
      console.log({ n1 });
      if (n1 > 0) {
        var flag = tr.PagePermissionFlag;
        console.log("PagePermissionFlag=" + flag);

        if (!flag) {
          this.$router.push("/access-denied");
        }

        var zone_name = this.$session.get("ZoneName");
        zone_name = zone_name == (null || undefined) ? 0 : zone_name;

        this.PageTitle = tr.PageTitle + " - " + zone_name;
        this.PageDescription = tr.PageDescription;
        this.FloatingButtonOptions = tr.FloatingButtonOptions;

        var CurrentJciYearId = parseInt(tr.CurrentJciYearId);
        console.log({ CurrentJciYearId });

        var YearName = parseInt(tr.CurrentJciYearName);
        console.log({ YearName });
        this.YearName = YearName;

        this.CurrentYearId = CurrentJciYearId;

        this.pageData();
      }
    },
  },
  created() {
    // this.initialize()
  },
  methods: {
    refreshPageData() {
      console.log("refreshPageData called");
      this.LoadingFlag = true;
      var url1 = "api/menu-details/show";
      var condition1 = {
        UserInterface: 1,
        Module: "jac_national_zone_award",
        Action: "preview",
      };
      this.getPageDetails("PageInfo", {}, url1, condition1);
    },
    pageData() {
      console.log("pageData called");

      var recordData = this.recordData;
      console.log({ recordData });
      this.getTableRecords();
    },
    closePrompt() {
      console.log("closePrompt called");
      this.$emit("hidePreviewRecordPrompt");
    },
    getTableRecords() {
      console.log("getTableRecords called");

      var AwardId = this.recordData.AwardId;
      console.log({ AwardId });

      if (AwardId > 0) {
        var server_url = companyConfig.apiURL;
        var token = this.$session.get("token");
        token = token == (null || undefined) ? 0 : token;
        var add_url = server_url + "api/award/show";
        var upload = {
          UserInterface: 1,
          Award: AwardId,
        };
        console.log("upload=" + JSON.stringify(upload));
        console.log(
          "server_url=" +
            server_url +
            ", token=" +
            token +
            ", add_url=" +
            add_url
        );

        this.RecordFlag = false;

        const thisIns = this;
        var output = "";
        var records = "";
        var successTxt = "";
        var errorTxt = "";
        var flag = 0;

        this.LoadingFlag = true;

        this.$http({
          url: add_url,
          method: "POST",
          data: upload,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
          onUploadProgress: function (progressEvent) {
            this.uploadPercentage = parseInt(
              Math.round((progressEvent.loaded / progressEvent.total) * 100)
            );
          }.bind(this),
        })
          .then(function (response) {
            console.log("response=" + JSON.stringify(response));

            thisIns.LoadingFlag = false;

            output = response.data.output;
            flag = response.data.flag;
            output = response.data.output;
            records = response.data.records;
            console.log("output=" + output + ", flag=" + flag);
            successTxt = response.data.success;
            errorTxt = response.data.error;
            console.log("successTxt=" + successTxt + ", errorTxt=" + errorTxt);

            thisIns.RecordFlag = flag;

            if (flag == 1) {
              console.log("records=" + JSON.stringify(records));

              thisIns.row = records;
              thisIns.toast("success", output);
            } else {
              thisIns.toast("error", output);
            }
          })
          .catch(function (error) {
            console.log("error=" + error);
            thisIns.toast("error", error);
            thisIns.LoadingFlag = false;
          });
      } else {
        var message = "Award details not found.";
        console.log("error=" + message);
      }
    },
  },
  beforeMount() {
    console.log("beforeMount called");

    // var RoleId = this.$session.get("RoleId");
    // RoleId = RoleId == (null || undefined) ? "" : RoleId;
    // console.log({ RoleId });
    // this.RoleId = RoleId;

    this.refreshPageData();
  },
};
</script>
<style lang="scss">
#lom-award-preview {
  .professional-preview-dialog {
    background-color: rgba(0, 0, 0, 0.05);
  }

  .main-preview-container {
    border-radius: 16px !important;
    overflow: hidden;
    max-width: 100%;
    background: #ffffff;
    box-shadow: 0 8px 40px rgba(0, 0, 0, 0.12) !important;
  }

  .professional-app-bar {
    position: relative;
    min-height: 80px;
    display: flex;
    align-items: center;
    overflow: hidden;

    .app-bar-background {
      position: absolute;
      inset: 0;
      background: linear-gradient(
        135deg,
        #1565c0 0%,
        #1976d2 25%,
        #1e88e5 50%,
        #2196f3 75%,
        #42a5f5 100%
      );

      .background-pattern {
        position: absolute;
        inset: 0;
        background-image: radial-gradient(
            circle at 25% 25%,
            rgba(255, 255, 255, 0.1) 2px,
            transparent 2px
          ),
          radial-gradient(
            circle at 75% 75%,
            rgba(255, 255, 255, 0.08) 1px,
            transparent 1px
          );
        background-size: 60px 60px, 40px 40px;
        animation: patternFloat 20s ease-in-out infinite;
      }
      .background-overlay {
        position: absolute;
        inset: 0;
        background: rgba(0, 0, 0, 0.1);
      }
    }

    .app-bar-content {
      position: relative;
      z-index: 2;
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: 100%;
      padding: 1.25rem 2rem;

      .left-section {
        display: flex;
        align-items: center;
        flex: 1;
        .app-bar-icon-wrapper {
          margin-right: 1.5rem;
          .app-bar-icon {
            background: rgba(255, 255, 255, 0.15);
            border-radius: 12px;
            padding: 0.5rem;
            border: 1px solid rgba(255, 255, 255, 0.2);
            box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
          }
        }
        .title-content {
          .app-bar-title {
            font-size: 1.75rem;
            font-weight: 700;
            color: white;
            margin: 0 0 0.25rem 0;
            text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
          }
          .app-bar-subtitle {
            font-size: 0.95rem;
            color: rgba(255, 255, 255, 0.9);
            margin-top: 4px;
          }
        }
      }

      .right-section {
        .action-buttons-wrapper {
          display: flex;
          align-items: center;
          gap: 0.5rem;
          .close-button {
            background: rgba(255, 255, 255, 0.15) !important;
            border: 2px solid rgba(255, 255, 255, 0.3) !important;
            color: white !important;
            font-weight: 600 !important;
            text-transform: none !important;
            padding: 0 1.5rem !important;
            height: 42px !important;
            border-radius: 21px !important;
            backdrop-filter: blur(10px);
          }
        }
      }
    }
  }

  .professional-loading-section {
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 300px;
    background: linear-gradient(45deg, #f5f7fa 0%, #c3cfe2 100%);
    .loading-text {
      font-size: 1.1rem;
      color: #1976d2;
      font-weight: 500;
      margin: 0;
      text-align: center;
    }
  }

  .main-content-wrapper {
    background: linear-gradient(to bottom, #f8f9fa 0%, #ffffff 100%);
    padding: 2rem !important;
  }

  .award-section-card {
    background: white;
    border-radius: 16px;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
    border: 1px solid rgba(25, 118, 210, 0.1);
    overflow: hidden;
    transition: all 0.3s;
    &:hover {
      box-shadow: 0 8px 30px rgba(0, 0, 0, 0.12);
      transform: translateY(-2px);
    }

    .section-header {
      background: linear-gradient(135deg, #f8f9fa 0%, #e3f2fd 100%);
      padding: 1.5rem 2rem;
      border-bottom: 1px solid rgba(25, 118, 210, 0.1);
      .section-title-wrapper {
        display: flex;
        align-items: center;
        .section-title {
          font-size: 1.4rem;
          font-weight: 600;
          color: #2c3e50;
          margin: 0;
        }
      }
    }
    .section-content {
      padding: 2rem;
    }
  }

  .detail-item {
    .detail-label {
      font-size: 0.875rem;
      font-weight: 600;
      color: #1976d2;
      margin-bottom: 0.5rem;
      display: flex;
      align-items: center;
    }
    .detail-value {
      font-size: 1rem;
      color: #2c3e50;
      font-weight: 500;
      margin: 0;
      padding: 0.75rem 1rem;
      background: #f8f9fa;
      border-radius: 8px;
      border-left: 4px solid #1976d2;
    }
  }

  .status-chip-wrapper .status-chip {
    font-weight: 600 !important;
    font-size: 0.875rem !important;
    padding: 0 16px !important;
    height: 36px !important;
    color: white !important;
  }

  .member-photo-section {
    display: flex;
    justify-content: center;
    margin-bottom: 1rem;
    .photo-container {
      position: relative;
      display: inline-block;
      .member-avatar {
        border: 4px solid #e3f2fd;
        transition: all 0.3s;
        &:hover {
          border-color: #1976d2;
          transform: scale(1.05);
        }
      }
      .photo-overlay {
        position: absolute;
        bottom: 0;
        right: 0;
        background: #1976d2;
        border-radius: 50%;
        width: 32px;
        height: 32px;
        display: flex;
        align-items: center;
        justify-content: center;
        border: 3px solid white;
      }
    }
  }

  .score-card {
    background: linear-gradient(135deg, #f3e5f5 0%, #ede7f6 100%);
    border: 1px solid #d1c4e9;
    box-shadow: 0 4px 18px rgba(124, 77, 255, 0.1);
    border-radius: 20px;
    transition: box-shadow 0.3s, transform 0.3s;
  }

  .award-jci-table.responsive-table {
    width: 100%;
    th,
    td {
      padding: 0.7rem 0.4rem;
      font-size: 1rem;
      text-align: center;
      vertical-align: middle;
    }
    th {
      background: #ede7f6;
      color: #7c4dff;
      font-weight: 600;
      border-bottom: 2px solid #d1c4e9;
    }
    td {
      background: #fff;
      border-bottom: 1px solid #f3e5f5;
    }
    .criteria-cell {
      display: flex;
      align-items: center;
      gap: 0.5rem;
      .criteria-text {
        font-weight: 500;
        font-size: 1rem;
        color: #512da8;
      }
    }
    .max-points-cell {
      color: #512da8;
      font-weight: 500;
    }
    .score-chip {
      box-shadow: 0 2px 8px rgba(124, 77, 255, 0.1);
      cursor: pointer;
      border-radius: 8px !important;
      font-size: 1rem !important;
      font-weight: 600 !important;
    }
    .score-row {
      animation: fadeInUp 0.6s;
      &:hover {
        background: #f3e5f5;
      }
    }
    .score-total-row {
      background: #ede7f6;
      font-size: 1.1rem;
      font-weight: 700;
    }
  }

  .question-answer-section .question-card,
  .question-answer-section .answer-card {
    background: white;
    border-radius: 12px;
    padding: 1.25rem;
    border: 1px solid #e0e0e0;
  }
  .question-card {
    border-left: 4px solid #ff9800;
    background: #fff3e0;
    .question-label {
      color: #f57c00;
    }
  }
  .answer-card {
    border-left: 4px solid #2196f3;
    background: #e3f2fd;
    .answer-label {
      color: #1976d2;
    }
    .answer-content {
      background: white;
      padding: 1rem;
      border-radius: 8px;
      border: 1px solid #e1f5fe;
    }
  }

  .attachments-grid .attachment-card {
    border-radius: 12px !important;
    overflow: hidden;
    border: 1px solid #e1bee7;
    &:hover {
      transform: translateY(-4px);
      box-shadow: 0 8px 25px rgba(156, 39, 176, 0.15) !important;
    }
  }
  .attachment-card-header {
    background: linear-gradient(135deg, #9c27b0 0%, #7b1fa2 100%);
    color: white;
    padding: 0.75rem 1rem;
    display: flex;
    align-items: center;
    gap: 0.5rem;
  }

  .professional-footer-actions {
    background: linear-gradient(135deg, #f8f9fa 0%, #e3f2fd 100%);
    border-top: 1px solid rgba(25, 118, 210, 0.1);
    padding: 2rem !important;
    .footer-content-centered {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 100%;
      .professional-close-btn {
        background: linear-gradient(
          135deg,
          #1976d2 0%,
          #1565c0 100%
        ) !important;
        color: white !important;
        font-weight: 600 !important;
        text-transform: none !important;
        border-radius: 12px !important;
        padding: 0 2rem !important;
        height: 48px !important;
        box-shadow: 0 4px 15px rgba(25, 118, 210, 0.3) !important;
      }
    }
  }

  @keyframes patternFloat {
    0%,
    100% {
      transform: translateY(0) rotate(0deg);
    }
    50% {
      transform: translateY(-10px) rotate(180deg);
    }
  }
  @keyframes fadeInUp {
    from {
      opacity: 0;
      transform: translateY(20px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  // Responsive tweaks
  @media (max-width: 1024px) {
    .app-bar-content {
      padding: 1rem 1.5rem;
      .app-bar-title {
        font-size: 1.5rem;
      }
    }
    .main-preview-container {
      margin: 0.5rem;
      border-radius: 12px !important;
    }
    .main-content-wrapper {
      padding: 1.5rem !important;
    }
  }
  @media (max-width: 768px) {
    .app-bar-content {
      padding: 0.75rem 1rem;
      flex-direction: column;
      align-items: flex-start;
      gap: 1rem;
      .app-bar-title {
        font-size: 1.25rem;
      }
    }
    .main-content-wrapper {
      padding: 1rem !important;
    }
    .footer-content-centered .professional-close-btn {
      width: 100%;
    }
  }

  // =============================================
  // ATTACHMENT PREVIEW CARDS - Modernized
  // =============================================
  .attachment-preview-card {
    border-radius: 12px !important;
    overflow: hidden;
    border: 1px solid #e1bee7;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    box-shadow: 0 4px 12px rgba(156, 39, 176, 0.1);

    &:hover {
      transform: translateY(-6px);
      box-shadow: 0 12px 28px rgba(156, 39, 176, 0.2);
    }

    .attachment-preview-header {
      background: linear-gradient(135deg, #9c27b0 0%, #7b1fa2 100%);
      color: white;
      padding: 1rem 1.25rem;
      display: flex;
      align-items: center;
      gap: 0.75rem;

      .attachment-preview-title {
        font-weight: 600;
        font-size: 0.95rem;
      }
    }

    .attachment-preview-content {
      padding: 1.25rem;

      .attachment-images {
        margin-bottom: 1.25rem;

        .images-grid {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(140px, 1fr));
          gap: 1rem;
          width: 100%;

          .image-preview-item {
            position: relative;
            border-radius: 8px;
            overflow: hidden;
            aspect-ratio: 1 / 1;
            cursor: pointer;
            box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);

            .preview-img {
              width: 100%;
              height: 100%;
              object-fit: cover;
              display: block;
              transition: transform 0.3s ease;
            }

            .image-overlay-preview {
              position: absolute;
              inset: 0;
              background: rgba(0, 0, 0, 0);
              display: flex;
              align-items: center;
              justify-content: center;
              transition: all 0.3s ease;
              opacity: 0;
            }

            &:hover {
              .preview-img {
                transform: scale(1.1);
              }

              .image-overlay-preview {
                background: rgba(0, 0, 0, 0.5);
                opacity: 1;
              }
            }
          }
        }
      }

      .attachment-details-info {
        background: #f5f5f5;
        padding: 1rem;
        border-radius: 8px;
        border-left: 4px solid #9c27b0;

        .detail-row-preview {
          display: flex;
          align-items: center;
          font-size: 0.9rem;

          .detail-label-preview {
            font-weight: 600;
            color: #424242;
            min-width: 50px;
          }

          .detail-value-preview {
            color: #666;
            flex: 1;
            word-break: break-word;
          }
        }
      }
    }
  }

  // =============================================
  // VIDEO SUBMISSION - Modernized
  // =============================================
  .section-header {
    &.video-header {
      background: linear-gradient(135deg, #ffebee 0%, #ffcdd2 100%);
    }

    .section-title-white {
      font-size: 1.4rem;
      font-weight: 600;
      color: white;
      margin: 0;
    }
  }

  .video-submission-wrapper {
    .video-info-alert {
      display: flex;
      align-items: flex-start;
      gap: 1rem;
      background: rgba(211, 47, 47, 0.04);
      border: 1px solid rgba(211, 47, 47, 0.2);
      border-radius: 8px;
      padding: 1.25rem;
      margin-bottom: 1.5rem;

      .video-alert-title {
        color: #d32f2f;
        font-weight: 700;
      }

      .video-alert-text {
        margin: 0.25rem 0 0 0;
        color: #666;
        font-size: 0.9rem;
      }
    }

    .video-player-container {
      border-radius: 12px;
      overflow: hidden;
      background: black;
      box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);

      .video-player {
        display: block;
        width: 100%;
        height: auto;
      }
    }
  }

  @media (max-width: 960px) {
    .attachment-preview-card {
      .attachment-preview-content {
        .attachment-images .images-grid {
          grid-template-columns: repeat(auto-fit, minmax(120px, 1fr));
          gap: 0.75rem;
        }
      }
    }
  }

  @media (max-width: 600px) {
    .attachment-preview-card {
      margin-bottom: 1rem;

      .attachment-preview-content {
        padding: 1rem;

        .attachment-images .images-grid {
          grid-template-columns: repeat(auto-fit, minmax(100px, 1fr));
          gap: 0.5rem;
        }
      }
    }

    .video-submission-wrapper {
      .video-info-alert {
        flex-direction: column;
        gap: 0.75rem;
      }
    }
  }
}
</style>